import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M.205 12v-1.023l3.84-4.204q.676-.739 1.114-1.284a4.8 4.8 0 0 0 .648-1.034q.216-.489.216-1.023 0-.614-.296-1.063a1.9 1.9 0 0 0-.795-.693 2.6 2.6 0 0 0-1.137-.244q-.67 0-1.17.278a1.9 1.9 0 0 0-.767.767q-.267.494-.267 1.16H.25q0-1.022.472-1.796A3.3 3.3 0 0 1 2.006.636Q2.823.205 3.84.205q1.023 0 1.812.431.79.432 1.24 1.165.448.733.448 1.63 0 .643-.233 1.256-.228.608-.795 1.358-.562.745-1.563 1.819l-2.614 2.795v.091h5.41V12H.204Zm13.482 0h-3.59V.364h3.75q1.692 0 2.897.699 1.205.693 1.847 1.994.642 1.295.642 3.102 0 1.819-.648 3.13a4.6 4.6 0 0 1-1.886 2.012Q15.46 12 13.687 12m-2.181-1.25h2.09q1.444 0 2.393-.557a3.43 3.43 0 0 0 1.414-1.585q.466-1.029.466-2.449 0-1.41-.46-2.426a3.4 3.4 0 0 0-1.375-1.568q-.916-.552-2.278-.551h-2.25z"
    }, null, -1)
  ])))
}
export default { render: render }